import APIClient from '@/shared/http/clients/api'

const resourceName = 'PDRFormularioItem'
const APIPci = process.env.APIBaseURLPci

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}`, data, config)

const PDRItemFormRepository = {
  GetAll
}
export default PDRItemFormRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdritemform.js